import React, {Component} from 'react';
import {gpn} from "../GPN"
import req from "../req";
import config from "../config";
import ModalLoading from "../sections/ModalLoading";

class Help extends Component {

    state = {
        help: "",

        loading: true
    };

    componentDidMount() {
        this.props.setTitle("راهنمای خرید اقساطی");
        req.getRequest(`${config.api}/user/help`)
            .then(r => {
                this.setState({
                    help: r.help,
                    loading: false
                });
            })
            .catch(err => {
                this.setState({
                    loading: false
                });
            });
    }


    render() {
        let {help, loading} = this.state;
        return (
            <div className="help">
                <ModalLoading loading={loading}/>
                <pre>{help}</pre>
            </div>
        );
    }
}

export default gpn(Help);